<template>
  <div class="flex flex-col p-5 mt-8 body-text-1 text-gray-700">
    <div v-if="isPayPalSubscription">
      <p class="body-text-4">
        Please contact our Customer Service Team to make adjustments to your monthly donation. You can reach them at
        <span class="text-brand-navy underline-offset-2 visited:text-brand-navy">support@cuddly.com</span>
      </p>
      <p class="body-text-4">
        Thank you!
      </p>
    </div>
    <span class="body-text-4" v-else>{{ error }}</span>
  </div>
</template>

<script>
import { PAGES } from '@/constants/externalPages'

export default {
  name: 'SubscriptionEditFailed',
  props: {
    error: {
      type: String,
      default: ''
    },
    subscription: {
      type: Object,
      required: true
    }
  },
  computed: {
    isPayPalSubscription() {
      return this.subscription?.method === 'paypal'
    }
  },
  methods: {
    handleContactUs() {
      return PAGES?.contact
        ? window.open(PAGES?.contact, '_blank', 'noreferrer')
        : undefined
    }
  }
}
</script>
